import { VisitDocumentSendCommand, VisitDocumentSendResult } from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { ActionEventInterceptor } from '@dreryk/react-components';

import {
   MedicalDocumentationShareFormBean,
   MedicalDocumentationShareFormSubmitHandler,
} from '~libs.desktop.shared.medical-documentation';
import {
   DocumentTemplatePreviewValues,
   documentTemplateValuesMapToVisitDocumentFieldValue,
} from '~libs.desktop.shared.document-template';

import { translationKeys } from '../../translations';

type VisitDocumentShareActionEventInterceptorRenderProps = {
   filePassword: string | null;
};

type VisitDocumentShareActionEventInterceptorProps = Readonly<{
   children: (renderProps: VisitDocumentShareActionEventInterceptorRenderProps) => JSX.Element;
   handleMedicalDocumentationShareSubmit: MedicalDocumentationShareFormSubmitHandler;
   visitId: number;
   printTemplateId: number;
   documentTemplateValues: DocumentTemplatePreviewValues;
}>;

export const VisitDocumentShareActionEventInterceptor = (
   props: VisitDocumentShareActionEventInterceptorProps
): JSX.Element => {
   const { executeAsync: sendVisitDocument, data } = useCqrsCommand<
      VisitDocumentSendResult,
      MedicalDocumentationShareFormBean
   >((parameters) => {
      const command = new VisitDocumentSendCommand();
      command.fieldValues = documentTemplateValuesMapToVisitDocumentFieldValue(props.documentTemplateValues);
      command.printTemplateId = props.printTemplateId;
      command.visitId = props.visitId;
      command.phoneNumber = parameters.phoneNumber!;
      command.emailAddress = parameters.emailAddress!;

      return command;
   });

   return (
      <ActionEventInterceptor
         action={props.handleMedicalDocumentationShareSubmit(sendVisitDocument)}
         blockingOperation={translationKeys.sendingDocumentation}
      >
         {props.children({
            filePassword: data?.password ?? null,
         })}
      </ActionEventInterceptor>
   );
};
